export const isAlphanumericWithSpaces = (
  value: string,
): boolean =>
  /^(?!.*\s{2})[a-zA-Z0-9]+(?:\s[a-zA-Z0-9]+)*$/.test(value);
